import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl, RequiredValidator, AbstractControl } from '@angular/forms';
import { AccessService } from '../service/access.service'
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalsConfirmAccessEmployeeContractorComponent } from './modals-confirm/modals-confirm.component';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { QualificationsModalComponent } from './qualifications-modal/qualifications-modal.component';
import {CustomsValidators} from '../../validators/custom.validators'
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';


@Component({
  selector: 'app-employe-access',
  templateUrl: './employe-access.component.html',
  styleUrls: ['./employe-access.component.css']
})
export class EmployeAccessComponent implements OnInit {
  oneSapZone: string
  oneSapSite: string
  buttonEnable: boolean= true
  //forms
  formAccessEmployee: UntypedFormGroup;
  RadioGroup: UntypedFormGroup;

  //calendar
  todayDate: Date;
  minDateEnd: string;
  sDate: string;
  eDate: string;
  maxDateTo: Date;

  //service
  selectZone: any = [];
  site: any = [];
  selectBusiness: any = [];
  selectSubZone: any = [];
  formTableEntry: any;
  selectCountry: any = [];


  description: string = null;
  descriptionSubzone: string = null;

  approverFacilityZone: any;
  approverFacilitySubZone: any;
  maxDate: any;

  formRadio: UntypedFormGroup;
  radioPress = false;
  controlNationalError = false;
  controlCountryError = false;
  controlSiteZoneCCError = false;
  controlDateAddError = false;
  controlRepeatPerson = false;
  controlNotFoundError = false;
  controlNotContractorError = false;
  controlPeopleInError = false;
  submited = false;
  dataEntries: any;
  approvers: any;
  dateValn=false;
  dateValn48 = false;

  siteCC: any;
  zoneCC: any;
  subzoneCC: any;

  siteIdParam: string;
  zoneIdParam: string;
  subZoneIdParam: string;
  options:any[];
  optionsApproverSubzone:any[];


  constructor(private formBuilder: UntypedFormBuilder,
    private dataApi: AccessService,
    private spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute) {

    this.dataEntries = [];
    this.approvers = [];
    this.RadioGroup = new UntypedFormGroup({
      radioBtn: new UntypedFormControl()
    });
    this.RadioGroup.controls['radioBtn'].setValue(String('false'));
    this.formTableEntry = [];
    this.todayDate = new Date();
    this.maxDate = new Date((this.todayDate.getFullYear() +environment.MaxYeardateAccessForms), this.todayDate.getMonth(),this.todayDate.getDate());
    this.minDateEnd = this.transformDate(new Date());
    this.siteIdParam = this.route.snapshot.queryParamMap.get('siteId');
    this.zoneIdParam = this.route.snapshot.queryParamMap.get('zoneId');
    this.subZoneIdParam = this.route.snapshot.queryParamMap.get('subZoneId');
    this.maxDateTo= new Date((this.todayDate.getFullYear() +environment.MaxYeardateAccessForms), this.todayDate.getMonth(),this.todayDate.getDate());

  }
  getEmployeeAccess() {
    this.spinner.show("loading");
    this.dataApi.getEmployeeAccess().subscribe((data: any) => {
      this.spinner.hide("loading");
      this.site = data.sites;
      this.selectBusiness = data.businessUnits;
      this.selectCountry = data.countries;
      if (this.siteIdParam != undefined) {
        this.formAccessEmployee.controls['siteId'].setValue(this.siteIdParam);
        this.changeSelectSite(this.siteIdParam);
      }
      if (this.zoneIdParam != undefined) {
        this.formAccessEmployee.controls['zoneId'].setValue(this.zoneIdParam);
        this.changeSelectZone(this.zoneIdParam);
      }
      if (this.subZoneIdParam != undefined) {
        this.RadioGroup.controls['radioBtn'].setValue('true');
        this.cleanSubzoneBU();
        this.formAccessEmployee.controls['subZoneId'].setValue(this.subZoneIdParam);
        this.getApproverSubZone(this.subZoneIdParam);
      }
      if(this.zoneIdParam!=null&& this.subZoneIdParam==null){
        this.changeNotBuGetApprover(this.zoneIdParam)
      }

    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }
  getlang(){

    return sessionStorage.getItem('lang');
  }
  dateValidation(dateStart,dataEnd )
  {

    this.dateValn=false;
    const startDate  = new Date(this.datePipe.transform(dateStart, "MM/dd/yyyy"));
    const endDate    = new Date(this.datePipe.transform(dataEnd, "MM/dd/yyyy"));
    
    
    //  let formatStart= parseInt(this.datePipe.transform(dateStart, "yyyyMMdd"))
    //  let formatEnd = parseInt(this.datePipe.transform(dataEnd, "yyyyMMdd"))

    // validation 30 days
    var Difference_In_Time = endDate.getTime() - startDate.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    if (Difference_In_Days >= 30)
    {
      this.dateValn=true;
    }else{
      this.dateValn=false;
    }


    // validation before 48 hours
    let dateToday = new Date();
    const today  = new Date(this.datePipe.transform(dateToday, "MM/dd/yyyy"));

    var Difference_In_Days48 = (startDate.getTime() - today.getTime()) / (1000 * 3600 * 24); 

    if (Difference_In_Days48 <= 2)
    {
      this.dateValn48=true;
    }else{
      this.dateValn48=false;
    }



  }

  openDialog() {
    this.dialog.open(ModalsConfirmAccessEmployeeContractorComponent, { panelClass: 'myapp-no-padding-dialog' }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.formAccessEmployee.controls['Confirm'].setValue(true);
      }
    });
  }
  seeQualifications(qualifications) {
    this.dialog.open(QualificationsModalComponent, { panelClass: 'myapp-no-padding-dialog', data: qualifications });
  }

  changeLimitDate(){

    switch(this.formAccessEmployee.controls['dateIndefinite'].value){
      case true:
        let dateToSelected =new Date( this.formAccessEmployee.controls['dateStart'].value)
        let dateUndefined = new Date (dateToSelected.setFullYear(dateToSelected.getFullYear()+environment.MaxYeardateAccessForms))
        this.formAccessEmployee.patchValue({dateEnd: dateUndefined})
        break;
      case false:
        this.formAccessEmployee.controls['dateEnd'].setValue("")
        break;
    }
  }
  ngOnInit() {
    this.formRadio = this.formBuilder.group({
      options: ['', Validators.required],
      ID: ['', [Validators.required,Validators.maxLength(10), CustomsValidators.validateRUN]],
      document: ['nationalId', Validators.required],
      countryId: ['', Validators.required]

    });
    this.formAccessEmployee = this.formBuilder.group({
      siteId: ['', Validators.required],
      zoneId: ['', Validators.required],
      subZoneId: ['', Validators.required],
      bussinesUnitID: ['', Validators.required],
      accessApproverId: this.formBuilder.control('', [Validators.required]),
      approverId:['', Validators.required],
      purpuse: [''],
      Confirm: [false, Validators.required],
      dateStart: ['', Validators.required],
      dateEnd: ['', Validators.required],
      facilityApproverId: [''],
      facilityPriority: ['true'],
      dateIndefinite: [false]
    });
    this.getEmployeeAccess();


  }

  public toFormControl(point: AbstractControl): UntypedFormControl {
    return point as UntypedFormControl;
   }
  changeSelectSite(siteId) {
    this.ApproverId.setValue([]);
    this.approverFacilityZone = null;
    this.approverFacilitySubZone = null;

    for (const siteOP of this.site) {
      if (siteOP.id === Number(siteId)) {
        this.selectZone = siteOP.zones;
        this.siteCC = siteOP.codeCC;
        this.oneSapSite = siteOP.code1Sap;


        if (this.oneSapSite==='0000')
        {
          
          this.buttonEnable = false
         
        }
        else 
        {
          this.buttonEnable= true

        }
        
      }
      this.formAccessEmployee.controls['zoneId'].setValue('');
      this.description = null;
      this.cleanSubzoneBU();
    }
  }


  cleanSubzoneBU() {
    this.dataEntries = [];
    this.formAccessEmployee.controls['accessApproverId'].setValue('');
    this.formAccessEmployee.controls['bussinesUnitID'].setValue('');
    this.formAccessEmployee.controls['subZoneId'].setValue('');

    this.descriptionSubzone = null;
    this.approverFacilitySubZone = null;


  }

  changeSelectZone(zoneId) {
    for (const zoneOP of this.selectZone) {
      if (zoneOP.id === Number(zoneId)) {
        if (zoneOP.subZones === undefined) {
          this.selectSubZone = [];
          this.oneSapZone = null;
        } else {
          this.selectSubZone = zoneOP.subZones;
          this.zoneCC = zoneOP.codeCC;
        }
        this.description = zoneOP.description;
        this.oneSapZone = zoneOP.code1Sap;
        //if (zoneOP.facilityState) {
        if (false) { //facility flow disabled
          this.spinner.show("loading");
          this.dataApi.getPeopleSearchByMDMID(zoneOP.approverId).subscribe(
            (response: any) => {
              this.approverFacilityZone = {
                fullName: response.firstName + " " + response.lastName,
                email: response.email,
                phone: response.phoneNumber,
                priority: zoneOP.priority,
                state: zoneOP.facilityState,
                mdmid: zoneOP.approverId
              }
              this.spinner.hide("loading");
            },
            () => {
              this.spinner.hide("loading");
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          )
        } else {
          this.approverFacilityZone = null;
        }


      }
      this.cleanSubzoneBU();
    }
  }

  getApproverSubZone(idSubzone) {
    this.dataEntries = [];
    this.formAccessEmployee.controls['accessApproverId'].setValue('');
    for (const subZoneOP of this.selectSubZone) {
      if (subZoneOP.id === Number(idSubzone)) {
        if (subZoneOP.description === undefined) {
          this.descriptionSubzone = null;
        } else {
          this.descriptionSubzone = subZoneOP.description;

          //if (subZoneOP.facilityState) {
          if (false) { //facility disabled
            this.spinner.show("loading");
            this.dataApi.getPeopleSearchByMDMID(subZoneOP.approverId).subscribe(
              (response: any) => {
                this.approverFacilitySubZone = { //llamada al get por mdmid
                  fullName: response.firstName + " " + response.lastName,
                  email: response.email,
                  phone: response.phoneNumber,
                  priority: subZoneOP.priority,
                  state: subZoneOP.facilityState,
                  mdmid: subZoneOP.approverId
                }
                this.spinner.hide("loading");
              },
              () => {
                this.spinner.hide("loading");
                this.dialog.open(ModErrorComponent, {
                  width: 'auto',
                  panelClass: 'myapp-no-padding-dialog',

                });
              }
            )
          } else {
            this.approverFacilitySubZone = null;
          }

          this.subzoneCC = subZoneOP.codeCC;
        }
      }
    }
    this.spinner.show("loading");
    this.dataApi.getApproverEmployeeSubZone(idSubzone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
        this.optionsApproverSubzone= []
        this.filteredOptionsApproverSubzone = this.formAccessEmployee.controls.accessApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
        );
      } else {


        this.approvers = data;
        this.optionsApproverSubzone= data.sort((a, b) => a[data.name] > b[data.name] ? 1 : a[data.name] === b[data.name] ? 0 : -1);;
        this.filteredOptionsApproverSubzone = this.formAccessEmployee.controls.accessApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
        );

      }
    }, () => {
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
  }
  sortBy(prop: string) {
    return this.approvers.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  changeBuGetApprover(idBu) {
    this.formAccessEmployee.controls.accessApproverId.setValue('');
    this.spinner.show("loading");
    this.dataApi.getApprovers(idBu, this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
      } else {
        this.approvers = data;
      }
    }, () => {
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
  }

  changeNotBuGetApprover(idZone) {
    this.ApproverId.setValue([]);
    this.changeSelectZone(idZone)
    this.formAccessEmployee.controls.accessApproverId.setValue('');
    this.spinner.show("loading");
    //this.oneSapZone=idZone;
    this.dataApi.getApproversNotBu(this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.filteredOptions = this.ApproverId.valueChanges
        this.approvers = [];
      } else {
        this.approvers = data;
        this.options= data.sort((a, b) => a[data.name] > b[data.name] ? 1 : a[data.name] === b[data.name] ? 0 : -1);;
        this.filteredOptions = this.ApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filter(name) : this.options.slice())
        );
      }
    }, () => {
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
  }

    //dropdown

    // myControl = new FormControl();
    ApproverId= new UntypedFormControl([Validators.required])
    // options= this.approvers;
    filteredOptions: Observable<any>;
    filteredOptionsApproverSubzone: Observable<any>;
    private _filterSubzoneApprovers(name: string): any[] {
    const filterValue = name.toLowerCase();
    const devolver = this.optionsApproverSubzone.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
      return  devolver;
    }
    displayFn(user: any): string {
      return user.mdmid && user.name ? user.name : '';
    }

    private _filter(name: string): any[] {
      const filterValue = name.toLowerCase();

      return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

  deletePeople(i) {
    this.dataEntries.splice(i, 1);
  }
  clearPersonDate() {
    let dateToSelected =new Date( this.formAccessEmployee.controls['dateStart'].value)
    this.maxDateTo = new Date (dateToSelected.setFullYear(dateToSelected.getFullYear()+environment.MaxYeardateAccessForms))
    this.dateValn48=false;
    this.formAccessEmployee.controls['dateEnd'].setValue('')
    this.formAccessEmployee.controls['dateIndefinite'].setValue(false)
    this.dataEntries = [];
  }
  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }
  add() {
    this.spinner.show("loading");
    this.radioPress = true;
    this.controlNationalError = false;
    this.controlDateAddError = false;
    this.controlRepeatPerson = false;
    this.controlNotFoundError = false;
    this.controlNotContractorError = false;
    this.controlCountryError = false;
    this.controlSiteZoneCCError = false;
    let doSearch = true;
    if (this.formAccessEmployee.controls['siteId'].hasError('required') && this.formAccessEmployee.controls['zoneId'].hasError('required')
      || (this.formAccessEmployee.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === 'true')
    ) {
      this.spinner.hide("loading");
      this.controlSiteZoneCCError = true;
      return;
    }

    if (this.formAccessEmployee.controls['dateStart'].hasError('required') ||
      this.formAccessEmployee.controls['dateEnd'].hasError('required')) {

    }
    if (this.formRadio.value.document === 'nationalId' && this.formRadio.controls['ID'].hasError('validateRUN')) {
      this.spinner.hide("loading");
      return;
    }


    if (this.formAccessEmployee.controls['dateStart'].hasError('required') ||
      this.formAccessEmployee.controls['dateEnd'].hasError('required')) {
      this.controlDateAddError = true;
      this.spinner.hide("loading");
      this.goTo('subzoneQ');
      return;
    }
    if (!this.formRadio.controls['document'].hasError('required')) {
      if (!this.formRadio.controls['ID'].hasError('required')) {
        if (this.formRadio.value.document === 'passportNumber' &&
          this.formRadio.controls['countryId'].hasError('required')) { //validation of nationality pending
          this.spinner.hide("loading");
          this.controlCountryError = true;
          return;
        }

        for (const person of this.dataEntries) {
          if (person.nationalId != '' && this.formRadio.value.document === 'nationalId') {
            if (String(person.nationalId).toLowerCase()  == String(this.formRadio.value.ID).toLowerCase() ) {
              doSearch = false;
              this.spinner.hide("loading");
              break;
            }
          } else if (person.passportNumber != '' && this.formRadio.value.document === 'passportNumber') {
            if (person.passportNumber.toLowerCase()  == this.formRadio.value.ID.toLowerCase()  && (String(this.formRadio.value.countryId) == person.nationality)) {
              doSearch = false;
              this.spinner.hide("loading");
              break;
            }
          }
        }
        let accessGroup = this.siteCC + '_' + this.zoneCC;
        if (this.RadioGroup.value.radioBtn == 'true') {
          accessGroup = accessGroup + '_' + this.subzoneCC;
        }
        if (doSearch) {
          // const zoneId = this.formAccessEmployee.value.zoneId
          // const subzoneId = this.formAccessEmployee.value.subZoneId
          const zoneId = this.formAccessEmployee.value.zoneId === undefined ? 0 : Number(this.formAccessEmployee.value.zoneId);
          const subzoneId = this.formAccessEmployee.value.subZoneId === undefined ? 0 :
            Number(this.formAccessEmployee.value.subZoneId);

          if (this.formRadio.value.document === 'nationalId') {
              let IdSPLIT = this.formRadio.value.ID.split('.').join('')
              this.formRadio.controls['ID'].setValue(IdSPLIT)
          }
          this.dataApi.getEmployeePeopleValidation(this.formRadio.value.document, this.formRadio.value.ID.toLowerCase() , this.formRadio.value.countryId,
            this.transformDate(this.formAccessEmployee.value.dateStart),
            this.transformDate(this.formAccessEmployee.value.dateEnd), zoneId, subzoneId).subscribe((data: any) => {
              if (data.status === 3) { //notFound Code:3
                this.controlNotFoundError = true;
              } else {
                if(data.status === 4){ //no contractor
                  this.controlNotContractorError = true;
                }else{
                  this.dataEntries.push(data)
                }

              }
              this.spinner.hide("loading");
            }, () => {
              this.spinner.hide("loading");
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            });
        } else {
          this.spinner.hide("loading");
          this.controlRepeatPerson = true;
        }
      } else { this.spinner.hide("loading"); }
    } else { this.spinner.hide("loading"); };

  }

  transformDate(date: Date) {
    return (this.datePipe.transform(date, 'yyyy-MM-dd'));
  }

  onSubmit() {
    this.spinner.show("loading");
    this.submited = true;
    this.controlPeopleInError = false;

    if (this.formAccessEmployee.controls['siteId'].hasError('required') || this.formAccessEmployee.controls['zoneId'].hasError('required')) {
      this.goTo('siteSection');
      this.spinner.hide("loading");
      return;
    }
    if (  (this.formAccessEmployee.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === true)
    ) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === 'false' && (this.ApproverId.value.mdmid==='' || this.ApproverId.value.mdmid===undefined || this.ApproverId.value.mdmid===null))
    {

      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.formAccessEmployee.controls['dateStart'].hasError('required') ||
      this.formAccessEmployee.controls['dateEnd'].hasError('required')) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }

    if (this.RadioGroup.value.radioBtn === 'true' && (this.formAccessEmployee.controls['accessApproverId'].value.mdmid==='' || this.formAccessEmployee.controls['accessApproverId'].value.mdmid===undefined || this.formAccessEmployee.controls['accessApproverId'].value.mdmid===null))
    {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    const AccessRequest = {
      requestorId: 1,
      siteId: this.formAccessEmployee.value.siteId,
      zoneId: this.formAccessEmployee.value.zoneId,
      subZoneId: this.formAccessEmployee.value.subZoneId === '' ? 0 : Number(this.formAccessEmployee.value.subZoneId),
     /*  siteId: Number(this.formAccessEmployee.value.siteId),
      zoneId: Number(this.formAccessEmployee.value.zoneId),
      subZoneId: Number(this.formAccessEmployee.value.subZoneId),*/
      businessUnitId: String(this.formAccessEmployee.value.bussinesUnitID),
      accessApproverId: this.RadioGroup.value.radioBtn === 'false' ? this.ApproverId.value.mdmid : this.formAccessEmployee.value.accessApproverId.mdmid,
      purpose: this.formAccessEmployee.value.purpuse,
      periodFrom: this.transformDate(this.formAccessEmployee.value.dateStart),
      periodTo: this.transformDate(this.formAccessEmployee.value.dateEnd),
      facilityApproverId: this.formAccessEmployee.value.facilityApproverId,
      facilityPriority: this.formAccessEmployee.value.facilityPriority,
      people: []
    }
    if (this.approverFacilityZone && this.approverFacilityZone.state && this.RadioGroup.value.radioBtn == 'false') {
      AccessRequest.facilityApproverId = this.approverFacilityZone.mdmid;
      AccessRequest.facilityPriority = this.approverFacilityZone.priority;
    } else {
      if (this.approverFacilitySubZone && this.approverFacilitySubZone.state &&
        this.RadioGroup.value.radioBtn == 'true') {
        AccessRequest.facilityApproverId = this.approverFacilitySubZone.mdmid;
        AccessRequest.facilityPriority = this.approverFacilitySubZone.priority;
      }
    }

    for (const item of this.dataEntries) {
      if (item.status === 0 || item.status === 1) {
        AccessRequest.people.push(item.mdmid);
      }
    }
    if (AccessRequest.people.length === 0) {
      this.controlPeopleInError = true;
      this.spinner.hide("loading");
      return;
    }
    if (AccessRequest.people.length > 100) {
      this._snackBar.open('you can enter a maximum of 100 people', '', {
        duration: 3000,
      });
      return;
    }
    if (this.formAccessEmployee.controls['Confirm'].hasError('required') || this.formAccessEmployee.controls['Confirm'].value === false) {
      this.spinner.hide("loading");
      return;
    }


     this.dataApi.postAccessEmployee(AccessRequest).subscribe((response) => {
       this.router.navigate(['/access-confirmation/' + response.requestNumber]);
       this.spinner.hide("loading");
     }, () => {
       this.spinner.hide("loading");
     })
  }
}
